/** 
    Copyright (C) 2024 Mathys Meunier

    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You can receive a copy of the GNU General Public License
    along with this program at "http://mathysmeunier/license".
*/

import { useState, useEffect } from 'react';
import defaultProject from "@/data/defaultProjects.json";
import overrideProject from "@/data/overrideProjects.json";
import { RepositoryInterface } from '@/interface/RepositoryInterface';

type RepoJson = {
    name: string,
    description: string,
    url?: string,
    language: string,
    owner?: {
        login: string,
        url: string,
        avatar: string
    }
    last_update: string
};
type RepoJsons = RepoJson[];

const repo_json_to_object = (json: RepoJson): RepositoryInterface => {
    const overp = overrideProject.find((p) => p.name === json.name) || null;
    return overp ? {
        ...json, ...overp, last_update:
            new Date(("last_update" in overp && typeof overp.last_update === "string")
                ? overp.last_update : json.last_update)
    } :
        ({ ...json, last_update: new Date(json.last_update) })
};

export default function useRepos() {
    return [{ "name": "Api-professionnel-sante-fr", "description": "Api en Python permettant d'obtenir des données en libre accès des professionnels de santé", "url": "https://github.com/Thysma23/Api-professionnel-sante-fr", "language": "Python", "last_update": "2024-02-13T08:25:01Z", "owner": { "login": "Thysma23", "url": "https://github.com/Thysma23", "avatar": "https://avatars.githubusercontent.com/u/87235242?v=4" } }, { "name": "Portfolio", "description": "Mon portfolio en ReactJS, inclue une API qui récupère mes projets GitHub.", "url": "https://github.com/Thysma23/Portfolio", "language": "TypeScript", "last_update": "2024-02-12T14:40:33Z", "owner": { "login": "Thysma23", "url": "https://github.com/Thysma23", "avatar": "https://avatars.githubusercontent.com/u/87235242?v=4" } }, { "name": "Portfolio-Angular", "description": "Mon portfolio refait en AngularJS", "url": "https://github.com/Thysma23/Portfolio-Angular", "language": "HTML", "last_update": "2024-02-05T22:55:41Z", "owner": { "login": "Thysma23", "url": "https://github.com/Thysma23", "avatar": "https://avatars.githubusercontent.com/u/87235242?v=4" } }, { "name": "MedicApp", "description": "An Application that allows users to scan prescriptions, medications, and sends notifications for intakes ", "url": "https://github.com/anrouxel/MedicApp", "language": "Kotlin", "last_update": "2024-01-29T09:37:59Z", "owner": { "login": "anrouxel", "url": "https://github.com/anrouxel", "avatar": "https://avatars.githubusercontent.com/u/59473377?v=4" } }, ...defaultProject].map(repo_json_to_object); // This is a temporary fix

    const [repos, setRepos] = useState<RepositoryInterface[]>(defaultProject.map(repo_json_to_object));

    useEffect(() => {
        fetch('http://localhost:8080/', {
            mode: "cors",
        }).then((response) => {
            console.log(response);
            response.json().then((datas: RepoJsons) => {
                setRepos(datas.map(repo_json_to_object).concat(defaultProject.map(repo_json_to_object)));
            });
        }).catch(error => console.error(error));
    }, []);

    return repos;
};  
